import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/style.css";
import App from "./App";
import { initAnalytics } from "./helpers/analytics";

initAnalytics();

ReactDOM.render(<App />, document.getElementById("main"));
